<template>
  <section
    class="address-section d-flex flex-column gr-6"
    data-qa="document_address_section"
    :class="isMobile ? '' : 'pa-6 elevation-1 rounded-sm'"
  >
    <div
      v-if="companyCardHref && !isMobile"
      class="d-flex justify-space-between align-center ga-4"
    >
      <h2
        class="text-h6 text--text ma-0"
        data-qa="document_address_title"
      >
        {{ title }}
      </h2>
      <DocumentDownloadLink
        :href="companyCardHref"
        :label="t('Скачать карточку компании', options)"
      />
    </div>
    <h2
      v-else
      class="text-h6 text--text ma-0"
      data-qa="document_address_title"
    >
      {{ title }}
    </h2>

    <ul
      class="address-section__list text-body-2 ma-0 pa-0"
      data-qa="document_address_list"
    >
      <li
        v-for="(item, index) in items"
        :key="`${String(item)}-${index}`"
        class="address-section__item mb-3"
        data-qa="document_address_item"
      >
        <template v-if="typeof item === 'string'">
          {{ item }}
        </template>
        <template v-else-if="item.type === 'address'">
          {{ item.prefix }}
          {{ formatCompanyAddress(physicalAddress, item.variant) }}
        </template>
        <template v-else-if="item.type === 'update'">
          {{ item.text }}
          <template
            v-for="(link, linkIndex) in item.links"
          >
            <span
              v-if="linkIndex > 0"
              :key="`sep-${link.href}`"
            >
              {{ t('и', options) }}
            </span>
            <a
              :key="link.href"
              :href="link.href"
              class="link-decoration-underline primary--text"
              data-qa="document_address_update_link"
              target="_blank"
              rel="noopener noreferrer"
            >
              {{ link.label }}
            </a>
          </template>
          {{ item.suffix }}
        </template>
      </li>
    </ul>

    <a
      v-if="headOfficeHref"
      :href="headOfficeHref"
      class="link-decoration-underline primary--text"
      data-qa="document_address_head_office_link"
      target="_blank"
      rel="noopener noreferrer"
    >
      {{ t('Перейти к реквизитам головной компании', options) }}
    </a>
  </section>
</template>

<script setup lang="ts">
import I18NextVue from 'i18next'
import DocumentDownloadLink from 'src/components/pages/info/document/index/components/DocumentDownloadLink.vue'
import formatCompanyAddress from 'src/components/pages/info/document/index/_functions/format-company-address'
import type {
  AddressUpdateNote,
  CompanyPhysicalAddress,
} from 'src/components/pages/info/document/index/types'

const { t, language } = I18NextVue
const options = { ns: language }

type AddressListItem = string | {
  type: 'address'
  prefix: string
  variant: 'legal' | 'actual'
} | AddressUpdateNote & { type: 'update' }

defineProps<{
  title: string
  items: AddressListItem[]
  companyCardHref?: string
  headOfficeHref?: string
  physicalAddress?: CompanyPhysicalAddress
  isMobile: boolean
}>()
</script>

<style scoped lang="scss">
.address-section {
  &__list {
    list-style: none;
  }

  &__item:last-child {
    margin-bottom: 0 !important;
  }
}
</style>
